import * as colors from '@trello/colors';

export const LabelColorMap: Record<string, string> = {
  green_light: colors.Green200,
  green: colors.Green400,
  green_dark: colors.Green600,
  yellow_light: colors.Yellow200,
  yellow: colors.Yellow400,
  yellow_dark: colors.Yellow600,
  orange_light: colors.Orange200,
  orange: colors.Orange400,
  orange_dark: colors.Orange600,
  red_light: colors.Red200,
  red: colors.Red400,
  red_dark: colors.Red600,
  purple_light: colors.Purple200,
  purple: colors.Purple400,
  purple_dark: colors.Purple600,
  blue_light: colors.TrelloBlue200,
  blue: colors.TrelloBlue300,
  blue_dark: colors.TrelloBlue600,
  sky_light: colors.Sky200,
  sky: colors.Sky400,
  sky_dark: colors.Sky600,
  lime_light: colors.Lime200,
  lime: colors.Lime400,
  lime_dark: colors.Lime600,
  pink_light: colors.Pink200,
  pink: colors.Pink400,
  pink_dark: colors.Pink600,
  black_light: colors.N400,
  black: colors.N600,
  black_dark: colors.N900,
  null: colors.N50,
};
